import { render, staticRenderFns } from "./AmericasmedicalcityExamesIntraOperatorios.vue?vue&type=template&id=4efe5a75&scoped=true"
import script from "./AmericasmedicalcityExamesIntraOperatorios.vue?vue&type=script&lang=ts"
export * from "./AmericasmedicalcityExamesIntraOperatorios.vue?vue&type=script&lang=ts"
import style0 from "./AmericasmedicalcityExamesIntraOperatorios.vue?vue&type=style&index=0&id=4efe5a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efe5a75",
  null
  
)

export default component.exports